if(window.innerWidth>750){
    var wFlag=true,box1W='23rem',box1d=0.5,box3S='top+=120% top+=6%'
}else{
    wFlag=false,box1W='19rem',box1d=0,box3S='top+=120% top+=7%'
}

$(()=>{
    ScrollTrigger.create({
        trigger:'.box1',
        // 'top top+=6%'
        start:'top top+=12%',
        end:'+=20%',
        // pin:true,
        // markers:true,
        animation:gsap.timeline()
            .to('.box1_icon1',{scale:1,x:0,y:0,rotate:0,opacity:1,duration:0.5})
            .to('.box1_icon2',{x:0,opacity:1,duration:box1d},'<')
            .to('.box1_border',{width:box1W,duration:0.5},'<')
            .to('.box1_border img',{x:0,duration:0.5},'<')
    })    

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top center',
            end:'+=0',
            // markers:true,
            animation:gsap.timeline()
                .from('.box2_left',{x:'-50%',opacity:0,duration:1})
                .from('.box2_right',{x:'50%',opacity:0,duration:1},'<')
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box2_left',
            start:'top center+=20%',
            end:'+=0',
            // markers:true,
            animation:gsap.timeline()
                .from('.box2_left',{y:'2rem',opacity:0,duration:1})
        })
        ScrollTrigger.create({
            trigger:'.box2_right',
            start:'top center+=20%',
            end:'+=0',
            // markers:true,
            animation:gsap.timeline()
            .from('.box2_right',{y:'2rem' ,opacity:0,duration:1})
        })
    } 
    
    ScrollTrigger.create({
        trigger:'.box2',
        start:'top center-=10%',
        end:'+=0%',
        // scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .from('.box2l_content p span',{opacity:0,y:'30%',stagger:0.1,duration:0.2})
            .from('.box2l_content div',{opacity:0,y:'2rem',duration:0.2})
    })

    gsap.from('.box3_title',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box3_title',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })

    ScrollTrigger.create({
        trigger:'.box3',
        start: box3S,
        end:'+=100%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box3_title div:nth-child(2)',{opacity:0,duration:0.1})
            .to('.box4_items',{opacity:0,duration:0.1},'<')
            .to('.box4',{scale:1.2,opacity:0,duration:0.2})
            .to('.box3_bg',{opacity:1,duration:0.2},'<')
            .to('.box3_title p',{backgroundImage:'linear-gradient(135deg,white,white)',duration:0.2},'-=50%')
            .to('.box3_btn',{background:'linear-gradient(150deg,#f7f6f4 50%,#d5cac8)',duration:0.2},'<')
            .to('.box3_btn span',{backgroundImage:'linear-gradient(135deg, #905d30 52%, #634020)',duration:0.2},'<')
            .to('.box3_title div:nth-child(3)',{opacity:1,duration:0.2})
            .to('.box3_text',{opacity:1,duration:0.2},'<')
    }) 

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=6%',
            end:'+=250%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                // 45
                for(let i=1;i<5;i++){
                    if(index>(i-1)*10){
                        $(`.box4_items .box4_item`).removeClass('box4_active')
                        $(`.box4_items .box4_item:nth-child(${i})`).addClass('box4_active')
                    }
                }
            },
        }) 
    }else{
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=7%',
            end:'+=200%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                // 45
                for(let i=1;i<5;i++){
                    if(index>(i-1)*10){
                        $('.Mbox4_items div').removeClass('Mbox4_active')
                        $(`.Mbox4_items div:nth-child(${i*2-1})`).addClass('Mbox4_active')

                        $(`.box4_items .box4_item`).removeClass('Mbox4_active2')
                        $(`.box4_items .box4_item:nth-child(${i})`).addClass('Mbox4_active2')
                    }
                }
            },
        }) 
    }

    gsap.to('.box5',{
        scrollTrigger:{
            trigger:'.box5',
            start:'top center',
            end:'+=0',
            // markers:true,
            onUpdate:(self)=>{
                var index = self.progress.toFixed(3) * 100
                if(index<2){
                    for(let i=1;i<$('.box5_img img').length+1;i++){
                        $(`.box5_img img:nth-child(${i})`).removeClass(`box5_active${i} box5_active`)
                    }
                }else{ 
                    for(let i=1;i<$('.box5_img img').length+1;i++){
                        $(`.box5_img img:nth-child(${i})`).addClass(`box5_active${i} box5_active`)
                    }
                }
            }
        }
    })
})